import { useParams } from "react-router-dom";
import { CarePlanGrid } from "../care-plan/CarePlanGrid";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { setPageTitle } from "../../store/slices/pageTitleSlice";

export const CarePlan = () => {

  const { patientId } = useParams<{ patientId: string }>();
  const dispatch = useDispatch();

    useEffect( () => {
        dispatch(setPageTitle('Care Plan: Patient Profile | Spire360'));
    }, []);

  return (
    <>
      <CarePlanGrid patientId={patientId}></CarePlanGrid>
    </>
  );
}

